// This is the decimal separator we use site-wide.
module.exports.decimalSeparator = ','
module.exports.decimalSeparatorTex = '{,}'